import './Home.scss'
import googleAppStoreLogo from "../../assets/google_play_logo.png";
import {Link as RouterLink} from "react-router-dom"
import { Link, Image } from "@fluentui/react-components";
import { useAuth } from "../../auth/AuthProvider";
import Recent from './Recent/Recent';

function Home()
{
    const {isAuthenticated} = useAuth();
    return (
        <div>
            <br/>
            <div className='container d-flex justify-content-center'>
                <div className='row'>
                    <div className='col-md-12 home-header'>
                        <h1>Experience Seamless Personal Safety</h1>
                    </div>                    
                </div>                            
            </div>            
            <br/>
            {!isAuthenticated && <div className='container'>
                <div className='d-flex justify-content-center'>                
                    <div>
                        <RouterLink to="/create-account"><Link appearance='button' className="message-action-button" shape="circular" size='large'>Your everyday safety companion</Link></RouterLink>
                    </div>  
                    <div>
                        <RouterLink to="/create-account"><Link appearance='button' className="call-action-button" shape="circular" size='large'>Create Account</Link></RouterLink>
                    </div>                
                </div>     
            </div>}
            <br/>
            <div className='container d-flex justify-content-center'>
                <div className='row'>
                    <div className='col-md-12 home-header'>
                        <h5>Elevate your physical security presence with our advanced technology powered by AI.</h5>
                    </div>                    
                </div>                
            </div>
            <br/>
            <div className='d-flex justify-content-center center-text'>
                <a href='https://play.google.com/store/apps/details?id=com.wrypai.app'>
                    <Image className='google-app-logo' alt="google play store logo" src={googleAppStoreLogo}/>
                </a> 
            </div>            
            <div className='d-flex justify-content-center center-text'>
                <div className='row'>
                    <div className='col-md-4'>
                        <h6>✓ Friendly interface for all</h6>
                    </div>
                    <div className='col-md-4'>
                        <h6>✓ All backgrounds available in one place</h6>
                    </div>
                    <div className='col-md-4'>
                        <h6>✓ identify people’s background</h6>
                    </div>
                </div>                
            </div>
            <br/>
            {isAuthenticated  && <Recent/>}
            <div className='faq-session'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-4'>
                            <h2>Frequently Asked Questions</h2>
                        </div>
                        <div className='col-md-4'>
                            <p><strong>What is Wryp.AI?</strong></p>
                            <p>Wrypai is a system that help you identify a person has any hidden background
                            </p>
                            <p><strong>How Wryp.AI works?</strong></p>
                            <p>
                                Submit a photo of a person and we do the rest of the work. Will check in our system if a user has any criminal record, wanted by a law enforcement agency or match any amber or silver alert
                            </p>                            
                        </div>
                        <div className='col-md-4'>
                            <p><strong>How to use Wryp.AI?</strong></p>
                            <p>Check before getting in a rideshare, open your door to the delivery guy or check someone at the bar
                            Your everyday safety companion, help you identify people’s background,
                            from sex offenders to wanted by international police or potentially risky persons.
                            Fastest way to identify Amber and Silver alerts or missing persons
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    );
}

export default Home;